import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageContainer from 'ui/PageContainer';
import Button from 'ui/Button';
import { LockClosedIcon } from '@heroicons/react/24/outline';

const Unauthorized: React.FC = () => {
    const navigate = useNavigate();

    return (
        <PageContainer>
            <div className="flex flex-col items-center justify-center min-h-[60vh]">
                <div className="text-center">
                    <LockClosedIcon className="w-14 h-14 mx-auto text-zinc-300 mb-5" strokeWidth={1.5} />
                    <h1 className="text-xl font-semibold text-zinc-900 mb-2">
                        접근 권한이 없습니다
                    </h1>
                    <p className="text-sm text-zinc-500 mb-6">
                        이 페이지에 접근할 수 있는 권한이 없습니다.<br />
                        관리자에게 문의하세요.
                    </p>
                    <Button
                        variant="primary"
                        onClick={() => navigate('/main/home')}
                    >
                        메인으로 돌아가기
                    </Button>
                </div>
            </div>
        </PageContainer>
    );
};

export default Unauthorized;
